<template>
  <div class="warp">
    <div class="newTop">
      <div class="container text">
        <span>想了解互联网最新动态</span>
        <p>资讯通通告诉你，想盈利就先抢占先机</p>
      </div>
    </div>
    <div class="container">
      <div class="brak"><b>您的位置：</b>
        <router-link to="/index">网站首页</router-link><span>></span>
        <router-link to="/newList">{{item.type==1?'公司快讯':item.type==2?'产品动态':'行业动态'}}</router-link>
      </div>
      <div class="content">
        <div class="title">{{item.title}}</div>
        <div class="contentHtml" v-html="item.content"></div>
      </div>
      <div class="btns">
        <button class="prev" :disabled="!item.preId" @click="changeProduct(item.preId)">上一篇</button>
        <button class="next" :disabled="!item.nextId" @click="changeProduct(item.nextId)">下一篇</button>
      </div>
    </div>
  </div>
</template>

<script>
import { getNewDetail } from "@/api/other";
export default {
  name: "",
  data() {
    return {
      active: 1,
      item: {},
    };
  },
  mounted() {
    this.active = this.$route.params.active;
    this.getNewDetail(this.$route.query.id);
  },
  methods: {
    getNewDetail(id) {
      getNewDetail(id).then((res) => {
        this.item = res;
      });
    },
    changeProduct(id) {
      let vm = this;
      document.body.scrollTop = 0;
      document.documentElement.scrollTop = 0;
      vm.getNewDetail(id);
      vm.$router.push({
        query: {
          id: id,
          active: vm.active,
        },
      });
    },
  },
};
</script>
<style lang='less' scoped>
.warp {
  background-color: #fff;
  padding-top: 1.45rem;
  box-sizing: border-box;
  padding-bottom: 1.2rem;
  .newTop {
    background: url("../../assets/images/newBanner.jpg") no-repeat center top;
    background-size: 140% auto;
    height: 7rem;
    .text {
      color: #fff;
      padding-top: 1.8rem;
      padding-left: 0.3rem;
      span {
        font-size: 0.6rem;
      }
      p {
        padding-top: 0.3rem;
        font-size: 0.32rem;
      }
    }
  }
  .brak {
    display: flex;
    align-items: center;
    font-size: 14px;
    margin-top: -58px;
    padding-left: 0.3rem;
    b {
      font-weight: bold;
    }
    span {
      padding: 0 5px;
    }
  }
  .content {
    padding: 0.8rem 0 0.4rem;
    .title {
      font-size: 0.5rem;
      text-align: center;
      padding-bottom: 0.5rem;
      font-weight: bold;
    }
  }
  .c {
    p {
      font-size: 14px;
    }
  }
  .btns {
    padding: .3rem;
    text-align: center;
    button {
      border: 1px solid #ddd;
      padding: 8px 20px;
      font-size: .4rem;
      cursor: pointer;
      &:hover {
        text-decoration: underline;
      }
    }
    .next {
      border-left: 0;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/view/new/newProduct.vue